/**
 * Weirwood
 * Copyright 2020 Baidu Inc. All rights reserved.
 *
 * @file 监控资源加载异常脚本
 * @author zengxiaohui(zengxiaohui@baidu.com)
 */
var MAX_URL_LENGTH = 255;
function getResourcePath(e) {
    var paths = e.path || [];
    var path = '';
    for (var i = 0; i < paths.length; i++) {
        var currentEl = paths[i];
        if (currentEl === window) {
            path += 'Window';
            continue;
        }
        path += currentEl.nodeName;
        path += currentEl.id ? '#' + currentEl.id : '';
        path += currentEl.className ? '.' + currentEl.className.split(' ').join('.') : '';
        if (i < paths.length) {
            path += ' > ';
        }
    }
    return path;
}
function getPath(url) {
    return (url || '').replace(/#.*$/, '').replace(/\?.*$/, '');
}
export function installResourceLoadErrorsHandler(cb) {
    window.addEventListener('error', function (e) {
        var _a;
        if (!e || !e.target) {
            return;
        }
        if (e.target === window) {
            return;
        }
        var el = e.target;
        var tagName = (_a = el === null || el === void 0 ? void 0 : el.tagName) !== null && _a !== void 0 ? _a : 'unknown tagname';
        // 如果是资源加载异常
        if (['SCRIPT', 'LINK', 'IMG'].indexOf(tagName) !== -1) {
            var sourceUrl = el.src || el.href;
            var href = window.location.href;
            var path = getResourcePath(e);
            var resourceErrorObj = {
                type: tagName,
                asset: getPath(sourceUrl) === getPath(href) ? '空资源' : sourceUrl,
                // Integrity metadata used in Subresource Integrity checks
                // Security Feature that allows browsers to verify what they fetch.
                // Only available on <script> and <link>
                // see https://www.w3.org/TR/SRI/#resource-integrity
                integrity: el.integrity,
                element: el && el.outerHTML && el.outerHTML.replace(/"/g, ''),
                path: path.replace(/"/g, ''),
                page: window.location.href.slice(0, MAX_URL_LENGTH)
            };
            cb && cb(resourceErrorObj);
        }
    }, true);
}
//# sourceMappingURL=resource-monitor.js.map